import React from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withIntl from "../../../utils/withIntl";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, IconButton, Typography } from "@material-ui/core";
import { useDialog } from "../../Dialogs/DialogProvider";
import { Close } from "@material-ui/icons";
import EditTextField from "../../EditArticle/EditTextField";
import EditPriceTextField from "../../EditArticle/EditPriceTextField";
import {
  updateModifierarticles,
  updateModifierarticlesTranslations,
} from "../../../store/articles/ModifierarticlesApi";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditSwitch from "../../EditArticle/EditSwitch";
import cloudStore from "../../../store/CloudStore";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import Chip from "@material-ui/core/Chip";
import TranslationSelection from "../../TranslationSelection/TranslationSelection";
import { getTranslationValue } from "../../../store/articles/ArticlesHelpers";
import LinkedItems from "../LinkedItems";
import { generatePath } from "react-router-dom";
import { ROUTE_URLS } from "../../../utils/routes/Routes";
import { updateArticle } from "../../../store/articles/ArticlesApi";
import EditCheckbox from "../../EditArticle/EditCheckbox";

const useStyles = makeStyles(() => ({
  marginBottom10: {
    marginBottom: 10,
  },
  rootDialog: { paddingBottom: 0 },
  rootChip: { fontSize: 10, padding: 1 },
  sizeSmall: { height: 16 },
  rootButton: {
    fontSize: 12,
    padding: 2,
    margin: 12,
  },
}));

function ModifierarticleDetailsDialog(props) {
  const classes = useStyles();
  const [, closeDialog] = useDialog();
  const [localCurrentLanguage, setLocalCurrentLanguage] = React.useState(props.currentLanguage);

  const updateTranslations = (value) => {
    return updateModifierarticlesTranslations(
      articlesStore.merchantId,
      [props.modifierarticle],
      [{ translation: { [props.currentLanguage]: value } }]
    ).then(() => {
      return Promise.resolve();
    });
  };

  const handleClickLanguage = (language) => {
    props.setCurrentLanguage(language);
    setLocalCurrentLanguage(language);
  };

  let linkedModifiergroups = [];

  props.modifierarticle.modifiergroupIds.forEach((id) =>
    linkedModifiergroups.push({
      name: articlesStore.modifiergroups[id].name,
      link:
        generatePath(ROUTE_URLS.MODIFIERGROUPS, { merchantId: cloudStore.merchant.id }) +
        `?searchValue=${articlesStore.modifiergroups[id].name}&modifiergroupId=${id}`,
    })
  );

  return (
    <>
      <DialogTitle id="form-dialog-title">
        <div style={{ display: "flex" }}>
          <Typography variant={"h5"}>{props.intl.formatMessage({ id: "option_article" })}</Typography>
          <TranslationSelection handleClickLanguage={handleClickLanguage} currentLanguage={localCurrentLanguage} />
        </div>
        <IconButton onClick={closeDialog} color="primary" style={{ position: "absolute", top: "8px", right: "8px" }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.rootDialog }} key={localCurrentLanguage}>
        <Grid container alignItems={"center"} spacing={1}>
          <Grid className={classes.marginBottom10} item xs={8}>
            <EditTextField
              authorizationField={
                "modifierarticle.name" +
                (localCurrentLanguage === cloudStore.merchant.default_language ? "" : ".other_language")
              }
              label={props.intl.formatMessage({ id: "option_article_name" })}
              placeholder={props.modifierarticle.name}
              value={getTranslationValue("name", "translation_id", localCurrentLanguage, props.modifierarticle, "")}
              onBlur={(value, setBeginValue) => {
                if (localCurrentLanguage === cloudStore.merchant.default_language) {
                  updateModifierarticles(
                    articlesStore.merchantId,
                    [props.modifierarticle],
                    [{ name: value }]
                  ).then(() => setBeginValue(value));
                } else {
                  updateTranslations(value).then(() => setBeginValue(value));
                }
              }}
              variant={"standard"}
            />
          </Grid>
          <Grid className={classes.marginBottom10} item xs={2}>
            <AuthorizationWrapper
              permission={"modifierarticle.id"}
              child={
                <Chip
                  classes={{ root: classes.rootChip, sizeSmall: classes.sizeSmall }}
                  variant="outlined"
                  label={"ID: " + props.modifierarticle.id}
                  size="small"
                  color="primary"
                />
              }
            />
          </Grid>
          <Grid className={classes.marginBottom10} item xs={2}>
            <AuthorizationWrapper
              permission={"modifierarticle.plu"}
              child={
                <Chip
                  classes={{ root: classes.rootChip, sizeSmall: classes.sizeSmall }}
                  variant="outlined"
                  label={"PLU: " + props.modifierarticle.plu}
                  size="small"
                  color="primary"
                />
              }
            />
          </Grid>
          <Grid className={classes.marginBottom10} item xs={8}>
            <EditTextField
              authorizationField={"modifierarticle.print_name"}
              label={props.intl.formatMessage({ id: "batch.print_name" })}
              value={props.modifierarticle.print_name ?? ""}
              onBlur={(value, setBeginValue) => {
                if (value === "") {
                  value = null;
                }
                updateModifierarticles(
                  articlesStore.merchantId,
                  [props.modifierarticle],
                  [{ print_name: value }]
                ).then(() => setBeginValue(value));
              }}
              variant={"standard"}
            />
          </Grid>
          <Grid className={classes.marginBottom10} item xs={4}>
            <EditPriceTextField
              authorizationField={"article.price"}
              label={props.intl.formatMessage({ id: "price" })}
              price={props.modifierarticle.price}
              onBlur={(value, setBeginValue) => {
                if (value == null) {
                  value = 0;
                }
                updateModifierarticles(articlesStore.merchantId, [props.modifierarticle], [{ price: value }]).then(() =>
                  setBeginValue(value)
                );
              }}
              variant={"standard"}
            />
          </Grid>
          <Grid className={classes.marginBottom10} item xs={6}>
            <EditTextField
              authorizationField={"modifierarticle.print_name_2"}
              label={props.intl.formatMessage({ id: "batch.print_name_2" })}
              value={props.modifierarticle.print_name_2 ?? ""}
              onBlur={(value, setBeginValue) => {
                if (value === "") {
                  value = null;
                }
                updateModifierarticles(
                  articlesStore.merchantId,
                  [props.modifierarticle],
                  [{ print_name_2: value }]
                ).then(() => setBeginValue(value));
              }}
              variant={"standard"}
            />
          </Grid>
          <Grid className={classes.marginBottom10} item xs={6}>
            <EditTextField
              authorizationField={"modifierarticle.pos_name"}
              label={props.intl.formatMessage({ id: "batch.pos_name" })}
              value={props.modifierarticle.pos_name}
              onBlur={(value, setBeginValue) => {
                updateModifierarticles(
                  articlesStore.merchantId,
                  [props.modifierarticle],
                  [{ pos_name: value }]
                ).then(() => setBeginValue(value));
              }}
              variant={"standard"}
            />
          </Grid>
          <Grid className={classes.marginBottom10} item xs={3}>
            <EditSwitch
              label={props.intl.formatMessage({ id: "batch.manual_active" })}
              authorizationField={"modifierarticle.manual_active"}
              value={!!props.modifierarticle.manual_active && !!props.modifierarticle.active}
              disabled={!props.modifierarticle.active && cloudStore.merchant?.merchantable_type != null}
              onChange={(newValue, setBeginValue) => {
                const value = newValue ? 1 : 0;
                updateModifierarticles(
                  articlesStore.merchantId,
                  [props.modifierarticle],
                  [{ manual_active: value, active: true }]
                ).then(() => setBeginValue(newValue));
              }}
            />
          </Grid>
          <Grid className={classes.marginBottom10} item xs={3}>
            <EditSwitch
              label={props.intl.formatMessage({ id: "batch.handheld_only" })}
              authorizationField={"modifierarticle.handheld_only"}
              value={props.modifierarticle.handheld_only}
              onChange={(newValue, setBeginValue) => {
                const value = newValue ? 1 : 0;
                updateModifierarticles(
                  articlesStore.merchantId,
                  [props.modifierarticle],
                  [{ handheld_only: value }]
                ).then(() => setBeginValue(newValue));
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <EditSwitch
              label={props.intl.formatMessage({ id: "batch.is_side_dish" })}
              authorizationField={"modifierarticle.is_side_dish"}
              value={props.modifierarticle.is_side_dish}
              onChange={(newValue, setBeginValue) => {
                const value = newValue ? 1 : 0;
                updateModifierarticles(
                  articlesStore.merchantId,
                  [props.modifierarticle],
                  [{ is_side_dish: value }]
                ).then(() => setBeginValue(newValue));
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <EditSwitch
              label={"Do not print on bill"}
              authorizationField={"article.doNotPrintOnTotalReceipt"}
              value={props.modifierarticle.meta_json?.doNotPrintOnTotalReceipt ?? false}
              onChange={(newValue, setBeginValue) => {
                updateModifierarticles(
                  articlesStore.merchantId,
                  [props.modifierarticle],
                  [{ meta_json: { doNotPrintOnTotalReceipt: newValue } }]
                ).then(() => setBeginValue(newValue));
              }}
            />
          </Grid>
        </Grid>
        <LinkedItems
          title={props.intl.formatMessage({ id: "linked_option_groups" })}
          linkedItems={linkedModifiergroups}
        />
      </DialogContent>
    </>
  );
}

export default withIntl(ModifierarticleDetailsDialog);
